import classNames from 'classnames/bind';
import styles from './ProjectRevenue.module.scss';
import { Box, Button, Link, TextField } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { PlusIcon, SearchIcon, TrashIcon } from '~/assets/icons';
import { useTranslation } from 'react-i18next';
import { DIALOG_MODE_CREATE, DIALOG_MODE_EDIT } from '~/utils/constants/common';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { catchError, handleApiError, notify } from '~/utils/helper';
import useDebounce from '~/hooks/useDebounce';
import ModalAlertDelete from '~/components/common/modal-alert-delete/ModalAlertDelete';
import { useNavigate } from 'react-router-dom';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import logo from '~/assets/images/logo.svg';
import { BaseImage } from '~/components/common';
import BaseTable from '../Table/BaseTable';
import { HeadCelType, SortDirection } from '~/utils/types/common';
import defaultImage from "~/assets/images/avatar_deafault.png"
import { Typography } from '@mui/material';
import { handleDashboardProjectRevenue } from '~/thunks/dashboard/dashboard';

const cx = classNames.bind(styles);

function formatDate(date: Date | string) {
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(new Date(date));
}

const ProjectRevenue = () => {
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState<string>('');
  const { t } = useTranslation(['admin/dashboard', 'admin/component']);
  const dispatch = useAppDispatch();
  const searchInputDebounce = useDebounce<string>(searchInput);
  const LIMIT_RECORD = 99999;
  const [projects, setProjects] = useState<any[]>([])

  const headCells: Array<HeadCelType> = useMemo(
    () => [
      {
        id: 'name',
        label: t('Project Name'),
        sortable: false,
        searchable: true,
      },
      {
        id: 'assignee',
        label: t('Client Name'),
        sortable: false,
        searchable: true,
      },
      {
        id: 'date',
        label: t('Start Date'),
        sortable: false,
        searchable: true,
      },
      {
        id: 'tags',  // New column
        label: t('Due Date'),
        sortable: false,
        searchable: true,
      },
      {
        id: 'status',
        label: t('Status'),
        sortable: false,
        searchable: true,
      },
      {
        id: 'Revenue',
        label: t('Revenue'),
        sortable: false,
        searchable: false,
        width: '5%'
      },
    ],
    [t]
  );
  useEffect(() => {

  }, [searchInputDebounce, dispatch]);


  const setSelectedIds = useCallback(
    (selected: Array<string>) => {
    },
    [dispatch]
  );


  const handleChangePage = (newPage: number) => {

  };

  const handleRequestSort = (sortBy: Array<{ orderBy: string; order: SortDirection }>) => {

  };

  const fetchData = () => {
    dispatch(handleDashboardProjectRevenue({
      filter: {
        page: 1,
        limit: 20
      }
    })).unwrap()
      .then((reponse: any) => {
        let data = reponse.data;
        setProjects(data);
      })
      .catch((error: any) => {

      })
      .finally(() => {

      });
  }

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Box className='w-full bg-[#071427] px-[30px] pt-[10px] pb-[24px] rounded-[8px]'>
      <Box className='mt-[14px] flex flex-col min-[1080px]:flex-row item-center'>
        <Box className='flex flex-col min-[1080px]:flex-row min-[1080px]:flex-1 min-[1080px]:justify-between '>
          <h2 className={cx('title')}>Project Revenue</h2>
          {/* <Box className='flex bg-[#2D80FC] rounded-full px-[12px] py-[6px] gap-1 cursor-pointer hover:opacity-80 justify-center items-center' 
          onClick={()=>{}}>
              <PlusIcon className='w-[12px] h-[12px]' stroke='#000000'/>
              <Typography className='truncate text-white text-[12px]'>Add Payment</Typography>
        </Box> */}
        </Box>
      </Box>
      <Box className='mt-[20px] bg-[#071427]'>
        <Box className=''>
          <BaseTable<any>
            data={projects}
            setSelectedIds={setSelectedIds}
            headCells={headCells}
            onChangePage={handleChangePage}
            onRequestSort={handleRequestSort}
            page={1}
            totalPages={1}
            sort={[]}
            showPagination={false}
            renderCell={(data: any) => {
              return (
                <>
                  <TableCell component='th' scope='row' >
                    <Box className='flex items-center gap-2'>
                      <BaseImage src={defaultImage} className={cx('image', 'w-[32px] h-[32px] rounded-full border-[2px] border-[#EEF3F2]')} />
                      <Typography className='text-white'>{data.projectName}</Typography>
                    </Box>
                  </TableCell>

                  <TableCell>
                    <Typography className='text-white'>{data.clientName}</Typography>
                  </TableCell>

                  <TableCell>
                    <Typography className='text-white'>{formatDate(new Date(data.startDate))}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography className='text-white'>{formatDate(new Date(data.endDate))}</Typography>
                  </TableCell>
                  <TableCell>
                    <Box className='bg-[#E3EDFD0D] rounded-full  w-fit px-[8px] py-[4px]'>

                      <Typography className="" sx={{
                        color: data.status == 'Completed' ? '#2D80FC' :
                          data.status == 'In progress' ? '#2DB3FC' : "#ff0000"
                      }}>
                        {data.status}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography className='text-white'>${data.revenue}</Typography>
                  </TableCell>
                </>
              );
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectRevenue;
